import { useMediaQuery } from '@mui/material'

type DeviceType = {
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
}

export const useDeviceType = (): DeviceType => {
  const isMobile = useMediaQuery('(max-width: 768px)')
  const isTablet = useMediaQuery('(max-width: 1024px)')
  const isDesktop = useMediaQuery('(min-width: 1025px)')

  return { isMobile, isTablet, isDesktop }
}
